import {VehicleViewTypeEnum} from '@/models/digital-document-queue-sender-transfer-protocol-form-model';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function vehicleViewTypeNameFilter(type: VehicleViewTypeEnum): string {
  switch (type) {
    case VehicleViewTypeEnum.Front: return i18n.t(LF.Front) as string;
    case VehicleViewTypeEnum.LeftSide: return i18n.t(LF.LeftSide) as string;
    case VehicleViewTypeEnum.RightSide: return i18n.t(LF.RightSide) as string;
    case VehicleViewTypeEnum.Back: return i18n.t(LF.Rear) as string;
    case VehicleViewTypeEnum.Interior: return i18n.t(LF.Interior) as string;
    case VehicleViewTypeEnum.Other: return i18n.t(LF.Other) as string;
    default: return '';
  }
}
